export const ActionTypes = {
  SET_PRICINGS: 'SET_PRICINGS'
};
